import { Injectable, ViewContainerRef, Inject } from '@angular/core';
import { DomAdapter, getDOM } from '@angular/platform-browser/src/dom/dom_adapter';
import { DOCUMENT } from '@angular/platform-browser';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';

import { ApiService } from '../core/api.service';
import { Mappings } from '../../shared/mapping';
import { LanguageService } from "../cms/language.service";

import { SeoService } from '../core/seo.service';
import { Meta } from '../core/angular2-meta';


@Injectable()
export class ScriptService {
    private _dom: DomAdapter = getDOM();
    constructor
        (
            public _api: ApiService,
            @Inject(DOCUMENT) private document: any,
            private mappings: Mappings,
            private language: LanguageService,
            private seo: SeoService,
            private metaService: Meta
        ) { }

    typeSystemPage: string = "systemPage";
    typeArticleCategory: string = "articleCategory";
    typeArticle: string = "article";
    typeCmsPage: string = "page";
    typeCatalogCategory: string = "category";
    typeCatalogOtherProduct: string = "otherProduct";
    typeCatalogProduct: string = "product";

    infoRequestId: string = "26";
    userAreaId: string = "18";
    privacyPolicyId: string = "36";
    purchaseConditionsId: string = "37";
    faqsId: string = "38";
    cookiesId: string = "35";
    homeId: string = "1";
    loginId: string = "2";
    blogHomeId: string = "40";
    productsCatalogId: string = "29";
    promotionsId: string = "16";
    cartId: string = "12";
    cartCashId: string = "15";
    cartSubmittedId: string = "43";
    userRegistrationId: string = "5";
    userRecoverPasswordId: string = "7";
    subscriptionId: string = "45";
    cartEmptyId: string = "42";
    ThankYouPagePaypalId: string = "47";
    ThankYouPagePagOnlineId: string = "48";
    ThankYouNexiId: string = "52";
    ThankYouRedsysId: string = "55";
    subscriptionConfirmationId: string = "46";
    registrationCompletePageId: string = "49"
    SearchPageId: string = "50"
    SearchWithPagingPageId: string = "51"

    getScript(type: string, rowId: string) {
        //reading language
        let longLang: string = this.language.getLongLang();

        let url: string = this.mappings.Web_Api_Get_Script
            .replace('{rowid}', rowId)
            .replace('{type}', type)
            .replace('{lang}', longLang)

        return this._api.get(url);
    }

    getScriptHead(type: string, rowId: string) {
        //reading language
        let longLang: string = this.language.getLongLang();

        let url: string = this.mappings.Web_Api_Get_Script_Head
            .replace('{rowid}', rowId)
            .replace('{type}', type)
            .replace('{lang}', longLang)

        return this._api.get(url);
    }

    checkIfScriptResponseIsValid(content) {
        let retVal = true;
        if (typeof content === 'object') //-- If it is object, it means that field is empty in backoffice
        {
            retVal = false
        }
        else if (typeof content === 'string') {
            if (!content) {
                retVal = false;
            }
        }
        else {
            retVal = false;
        }

        return retVal;
    }

    getSystemPageRowId_OrderId(PageRowId, OrderId) {
        return PageRowId + "_" + OrderId;
    }

    setupExternalScripts(result, pageType, id) {
        //-- Retrieving the script to append
        if (result.SeoInformation.HasScripts) {
            this.getScriptHead(pageType, id).subscribe(response => {
                let isValidResponse = this.checkIfScriptResponseIsValid(response);
                if (isValidResponse) {
                    this.seo.appendScriptsToDOM(this.document.head, response);
                }
            });

            this.getScript(pageType, id).subscribe(response => {
                let isValidResponse = this.checkIfScriptResponseIsValid(response);
                if (isValidResponse) {
                    this.seo.appendScriptsToDOM(this.document.body, response);
                }
            });
        }
    }

    setGoogleScripts(seoInfo,countRecursive=0) {
        if (!seoInfo)
            return;

        //-- Updating title on client side
        if (seoInfo.Title)
            this.metaService.setTitle(seoInfo.Title);

        //-- Update google analytics
        if (seoInfo.HasScripts && seoInfo.AnalyticsId)
        {
            try {
                gtag('config', seoInfo.AnalyticsId, { 'page_path': seoInfo.UrlForSeo });
            } catch (error) {
                if(countRecursive>3)
                {
                return;
                }
                countRecursive++;
                this.setGoogleScripts(seoInfo,countRecursive);
            }
        }
            
            
            
           
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/cms/script.service.ts